import type { IRegionRepository } from '@/domain/repositories/region.repository'
import type { GetRegionsParams, RegionListResult, Region } from '@/domain/entities/region.entity'
import { regionsContract } from '@bibleawr/landing2-contract'
import { createLandingTsRestClient } from '../api/ts-rest-client'
import { toStringOrUndefined } from '@/utils/value.helpers'

function mapResponseToRegion (dto: {
  _id?: string
  region_iso?: string
  region_name?: string
}): Region {
  return {
    _id: dto._id ?? '',
    region_iso: dto.region_iso ?? '',
    region_name: dto.region_name ?? '',
  }
}

export class RegionRepository implements IRegionRepository {
  private readonly client = createLandingTsRestClient(regionsContract)

  async findMany (params?: GetRegionsParams): Promise<RegionListResult> {
    const res = await this.client.getRegions({
      query: {
        cursor: params?.cursor,
        limit: params?.limit,
        regionIso: params?.regionIso,
        search: params?.search,
        locale: params?.locale,
      },
    })

    if (res.status !== 200) {
      throw new Error(`RegionRepository.findMany failed with status ${res.status}`)
    }

    const items = (res.body.data ?? []).map(mapResponseToRegion)
    const pagination = res.body.pagination
    const limit = pagination?.limit ?? params?.limit ?? 50
    const cursor = toStringOrUndefined(pagination?.cursor)
    const hasNextPage = pagination?.hasNextPage ?? items.length >= limit

    return { items, cursor, limit, hasNextPage }
  }
}
